import React from "react";

import { IconProps } from "../types";

import { Path } from "./Path";

export const Star = ({ className, color }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    className={className}
  >
    <Path
      color={color}
      d="M12 17.7212L18.18 21.4512L16.54 14.4212L22 9.69117L14.81 9.08117L12 2.45117L9.19 9.08117L2 9.69117L7.46 14.4212L5.82 21.4512L12 17.7212Z"
    />
  </svg>
);
